
<nav class="c-category-menu">
  <transition
    :name="`slide-${slideDirection}`"
    mode="out-in"
  >
    <div
      :key="selectedCategory && selectedCategory.slug"
      class="c-category-menu__block"
      :class="{ '-returnable': !!selectedCategory }"
    >
      <span class="c-category-menu__title">
        <template v-if="!selectedCategory">
          Departamentos
        </template>
        <template v-else>
          <button
            class="c-category-menu__back"
            @click="back"
          >
            <vIcon
              name="arrow-left"
              color="primary"
            />
          </button>

          {{ selectedCategory.name }}
        </template>
      </span>

      <ul class="c-category-menu__list">
        <li
          v-if="selectedCategory"
          class="c-category-menu__item"
        >
          <a
            class="c-category-menu__link-subcategory"
            :href="categoryLink(selectedCategory)"
            :data-testid="`button-bar-category-${selectedCategory.slug}`"
          >
            Tudo de {{ selectedCategory.name }}
          </a>
        </li>

        <category-menu-item
          v-for="item in visibleCategories"
          :key="item.slug"
          :name="item.name"
          :slug="item.slug"
          :has-children="!!item.children.length"
          :path="categoryLink(item)"
          :is-selected="isSelected(item.slug)"
          @select="select"
        />

        <li
          v-if="!selectedCategory"
          class="c-category-menu__item has-children"
        >
          <a
            class="c-category-menu__link"
            href="/enjoei-pro"
            data-testid="button-bar-category-enjoei-pro"
            @click="registerInteraction('pro')"
          >
            enjoei pro
          </a>
        </li>
      </ul>
    </div>
  </transition>
</nav>
